import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";

const isMac = typeof navigator !== "undefined" && navigator.platform.includes("Mac");

function KbdKey({ children }) {
  return (
    <kbd className="inline-block ml-1.5 px-1 py-0 text-[10px] font-mono font-bold rounded leading-[18px]"
      style={{
        background: "rgba(255,255,255,0.08)",
        border: "1px solid rgba(255,255,255,0.15)",
        color: "rgba(255,255,255,0.7)",
        boxShadow: "0 1px 0 rgba(255,255,255,0.06)",
      }}>
      {children}
    </kbd>
  );
}

function formatShortcut(shortcut) {
  if (!shortcut) return null;
  return shortcut
    .split("+")
    .flatMap(p => p.trim().split(" "))
    .map(k => {
      const map = {
        mod: isMac ? "\u2318" : "Ctrl",
        shift: isMac ? "\u21E7" : "Shift",
        alt: isMac ? "\u2325" : "Alt",
        space: "Space",
        escape: "Esc",
        enter: "\u21B5",
        "?": "?",
      };
      return map[k] || k.toUpperCase();
    });
}

/**
 * NavTooltip — wraps a trigger element with a themed tooltip.
 *
 * @param {string} label - Primary label text
 * @param {string} [shortcut] - Keyboard shortcut (e.g. "mod+k", "space", "g d")
 * @param {string} [description] - Optional secondary description
 * @param {"top"|"bottom"|"left"|"right"} [side="bottom"] - Tooltip side
 * @param {React.ReactNode} children - The trigger element (must accept ref)
 */
export default function NavTooltip({ label, shortcut, description, side = "bottom", children }) {
  const keys = formatShortcut(shortcut);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {children}
      </TooltipTrigger>
      <TooltipContent side={side}>
        <div className="flex items-center gap-1">
          <span>{label}</span>
          {keys && (
            <span className="flex items-center gap-0.5 ml-1">
              {keys.map((k, i) => <KbdKey key={`${k}-${i}`}>{k}</KbdKey>)}
            </span>
          )}
        </div>
        {description && (
          <div className="text-[11px] mt-0.5" style={{ color: "rgba(255,255,255,0.5)" }}>
            {description}
          </div>
        )}
      </TooltipContent>
    </Tooltip>
  );
}
